export default __webpack_public_path__ + "static/media/icon-dotwhack.7f661606.svg";